export default {
  computed: {
    isManager() {
      if (this.$store.getters['auth/tokenPayload']().type === 'manager')
        return true;
      return false;
    }
  }
};
